import { Button } from "../../Components/ui/button";
import { useNavigate, useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { RootState } from "../../State/store";

// Mock Card components
const Card = ({ children, className = "" }: { children: React.ReactNode; className?: string }) => (
  <div className={`bg-white border rounded-lg shadow-sm ${className}`}>{children}</div>
);
const CardContent = ({ children, className = "" }: { children: React.ReactNode; className?: string }) => (
  <div className={`${className}`}>{children}</div>
);

const StatusBox = ({ label, status }: { label: string; status: string }) => {
  const isApproved = status.toLowerCase() === "approved";
  const isPartial = status.toLowerCase() === "partial approved";
  const isRejected = status.toLowerCase() === "rejected";
  const hideStatusText = label === "Start" || label === "End" || label === "Campaign Creation";
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate("/navbar/campaignlist");
  };

  return (
    <div className="flex flex-col items-center min-w-[140px]">
      <div className="fixed flex justify-end items-center right-0 top-[-15px] z-20 p-4">
        <Button
          onClick={handleBackClick}
          className="w-30 text-sm text-[#F8FAFC] font-medium h-[35px] mt-[10px] cursor-pointer"
        >
          Back
        </Button>
      </div>
      <div
        className={`rounded-md px-6 py-6 text-sm font-semibold w-full text-center ${
          isApproved
            ? "bg-blue-600 text-white"
            : isPartial
            ? "bg-blue-400 text-white"
            : isRejected
            ? "bg-red-600 text-white"
            : "bg-gray-200 text-gray-600"
        }`}
      >
        {label}
      </div>
      <div
        className={`text-xs mt-2 ${
          isApproved || isPartial 
            ? "text-gray-600" 
            : isRejected 
            ? "text-red-600" 
            : "text-gray-400"
        } ${hideStatusText ? "invisible" : ""}`}
      >
        {isApproved 
          ? "Approved" 
          : isPartial 
          ? "Partially Approved" 
          : isRejected 
          ? "Rejected" 
          : "Pending"}
      </div>
    </div>
  );
};

export default function ApprovalTimeline() {
  const location = useLocation();
  const campaignId = location.state?.campaign_id ? Number(location.state.campaign_id) : undefined;
  const apiUrlAdvAcc = useSelector((state: RootState) => state.authentication.apiURL);
  const [steps, setSteps] = useState<{ label: string; status: string }[]>([]);
  const [verticalTimeline, setVerticalTimeline] = useState<any[]>([]);

  // const GetVerticalTimeline = async (horizontalSteps: { label: string; status: string }[]) => {
  //   try {
  //     const response = await axios.get(`${apiUrlAdvAcc}/GetVerticalTimelineForAdvertiser`, {
  //       params: { campaign_id: campaignId },
  //     });

  //     if (response.data.status === "Success") {
  //       let timeline = response.data.data;

  //       // ✅ Find index of "Campaign Created"
  //       const createdIndex = timeline.findIndex((item: any) =>
  //         item.title?.toLowerCase().includes("campaign created")
  //       );

  //       // ✅ Find "Admin Rejected" and "Admin Resubmitted" entries
  //       const adminRejected = timeline.find((item: any) =>
  //         item.title?.toLowerCase().includes("admin rejected")
  //       );

  //       const campaignResubmitted = timeline.find((item: any) =>
  //         item.title?.toLowerCase().includes("campaign resubmitted")
  //       );

  //       // ✅ Remove existing Approval Status if exists
  //       timeline = timeline.filter(
  //         (item: any) => item.title?.toLowerCase() !== "approval status"
  //       );

  //       // ✅ Determine Approval Status based on the horizontal timeline status
  //       let approvalStatus = "pending";
  //       let approvalTime = "Pending";
        
  //       // Use the horizontalSteps parameter instead of state
  //       if (horizontalSteps.length > 0) {
  //         // Find the "Approval Status" step in horizontal timeline
  //         const approvalStep = horizontalSteps.find(step => 
  //           step.label.toLowerCase().includes("approval status")
  //         );
          
  //         if (approvalStep && approvalStep.status === "approved") {
  //           approvalStatus = "approved";
  //           approvalTime = "Approved";
  //         }
  //       }

  //       // ✅ Create Approval Status node
  //       const approvalStatusNode = {
  //         title: "Approval Status",
  //         time: approvalTime,
  //         status: approvalStatus,
  //         comment: null,
  //         event_time: new Date().toISOString(),
  //       };

  //       // ✅ Decide where to insert Approval Status
  //       const insertIndex =
  //         createdIndex + 1 +
  //         (adminRejected ? 1 : 0) +
  //         (campaignResubmitted ? 1 : 0);

  //       timeline.splice(insertIndex, 0, approvalStatusNode);

  //       // ✅ Update the vertical timeline state
  //       setVerticalTimeline(timeline);
  //     } else {
  //       console.warn("Vertical timeline fetch failed:", response.data.status_Description);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching vertical timeline:", error);
  //   }
  // };

  const GetVerticalTimeline = async (horizontalSteps: { label: string; status: string }[]) => {
  try {
    const response = await axios.get(`${apiUrlAdvAcc}/GetVerticalTimelineForAdvertiser`, {
      params: { campaign_id: campaignId },
    });

    if (response.data.status === "Success") {
      let timeline = response.data.data;

      // ✅ Find index of "Campaign Created"
      const createdIndex = timeline.findIndex((item: any) =>
        item.title?.toLowerCase().includes("campaign created")
      );

      // ✅ Find "Admin Rejected" and "Admin Resubmitted" entries
      const adminRejected = timeline.find((item: any) =>
        item.title?.toLowerCase().includes("admin rejected")
      );

      const campaignResubmitted = timeline.find((item: any) =>
        item.title?.toLowerCase().includes("campaign resubmitted")
      );

      // ✅ Remove existing Approval Status if exists
      timeline = timeline.filter(
        (item: any) => item.title?.toLowerCase() !== "approval status"
      );

      // ✅ Determine Approval Status based on the horizontal timeline status
      let approvalStatus = "pending";
      let approvalTime = "Pending";
      
      // Use the horizontalSteps parameter instead of state
      if (horizontalSteps.length > 0) {
        // Find the "Approval Status" step in horizontal timeline
        const approvalStep = horizontalSteps.find(step => 
          step.label.toLowerCase().includes("approval status")
        );
        
        if (approvalStep && approvalStep.status === "approved") {
          approvalStatus = "approved";
          approvalTime = "Approved";
        }
      }

      // ✅ Create Approval Status node
      const approvalStatusNode = {
        title: "Approval Status",
        time: approvalTime,
        status: approvalStatus,
        comment: null,
        event_time: new Date().toISOString(),
      };

      // ✅ Insert Approval Status at the end of the timeline
      const insertIndex = timeline.length;

      timeline.splice(insertIndex, 0, approvalStatusNode);

      // ✅ Update the vertical timeline state
      setVerticalTimeline(timeline);
    } else {
      console.warn("Vertical timeline fetch failed:", response.data.status_Description);
    }
  } catch (error) {
    console.error("Error fetching vertical timeline:", error);
  }
};

  useEffect(() => {
    const GetHorizontalTimelineStatus = async () => {
      try {
        const response = await axios.get(`${apiUrlAdvAcc}/GetHorizontalTimelineStatusforAdvertiser`, {
          params: {
            campaign_id: campaignId,
          }
        });
        if (response.data.status === "Success") {
          const apiSteps = response.data.data.map((item: any) => ({
            label: item.stage,
            status: item.status.toLowerCase(),
          }));
          setSteps(apiSteps);
          
          // ✅ Pass the steps data directly to GetVerticalTimeline
          await GetVerticalTimeline(apiSteps);
        } else {
          console.warn("No timeline status found");
        }
      } catch (error) {
        console.error("Error fetching horizontal timeline status:", error);
      }
    };

    if (campaignId) {
      GetHorizontalTimelineStatus();
    } else {
      console.warn("Missing required parameters:", { campaignId });
    }
  }, [campaignId, apiUrlAdvAcc]);

  return (
    <div className="p-8 bg-white min-h-screen">
      {/* Horizontal Status Bar */}
      <div className="flex items-center justify-center w-full max-w-6xl mx-auto mb-16">
        {steps.map((step, index) => (
          <React.Fragment key={index}>
            <StatusBox label={step.label} status={step.status} />
            {index < steps.length - 1 && (
              <div
                className={`h-1 w-10 mt-4 mb-8 top-[-10px] ${
                  step.status === "approved" && steps[index + 1]?.status === "approved" 
                    ? "bg-blue-600" 
                    : "bg-gray-300"
                }`}
              ></div>
            )}
          </React.Fragment>
        ))}
      </div>

      {/* Vertical Timeline */}
      <div className="flex justify-center mb-16">
        <div className="relative max-w-4xl w-full">
          <div className="relative z-10">
            {verticalTimeline.map((event: any, index: number) => {
              const isLeftSide = index % 2 === 0;
              const isPending = !event.status || event.status.toLowerCase() === "pending";
              const isRejected = event.status && event.status.toLowerCase() === "rejected";

              const dotColor = isPending 
                ? "bg-gray-400" 
                : isRejected 
                ? "bg-red-600" 
                : "bg-blue-600";
              const textColor = isPending 
                ? "text-gray-400" 
                : isRejected 
                ? "text-red-700" 
                : "text-blue-700";
              const timeColor = isPending 
                ? "text-gray-300" 
                : isRejected 
                ? "text-red-500" 
                : "text-gray-500";

              return (
                <div key={index} className="relative py-8 pb-12 flex items-start">
                  {index < verticalTimeline.length - 1 && (
                    <div className="absolute left-1/2 top-3 h-full w-0.5 bg-blue-600 transform -translate-x-1/2 z-0" />
                  )}
                  <div
                    className={`absolute left-1/2 top-3 w-3 h-3 rounded-full ${dotColor} transform -translate-x-1/2 z-10`}
                  />

                  {/* Left Side */}
                  <div className="w-1/2 flex justify-end pr-4">
                    <div className="w-72 -mt-6">
                      {isLeftSide ? (
                        <div className="text-right">
                          <div className={`text-sm font-semibold ${textColor}`}>{event.title}</div>
                          {event.time && <div className={`text-xs ${timeColor} mt-1`}>{event.time}</div>}
                        </div>
                      ) : (
                        <div className="flex justify-end">
                          {event.comment && (
                            <Card className={`${
                              isPending 
                                ? "border-gray-200 bg-gray-50" 
                                : isRejected 
                                ? "border-red-200 bg-red-50" 
                                : "border-blue-200 bg-blue-50"
                            } max-w-xs`}>
                              <CardContent className="p-4">
                                <div className={`text-sm font-semibold ${textColor} mb-2`}>{event.comment.title}</div>
                                <div className={`text-sm break-words whitespace-pre-wrap ${
                                  isPending 
                                    ? "text-gray-400" 
                                    : isRejected 
                                    ? "text-red-600" 
                                    : "text-blue-600"
                                }`}>{event.comment.content}</div>
                              </CardContent>
                            </Card>
                          )}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Right Side */}
                  <div className="w-1/2 flex justify-start pl-4">
                    <div className="w-72 -mt-6">
                      {!isLeftSide ? (
                        <div className="text-left">
                          <div className={`text-sm font-semibold ${textColor}`}>{event.title}</div>
                          {event.time && <div className={`text-xs ${timeColor} mt-1`}>{event.time}</div>}
                        </div>
                      ) : (
                        <div className="flex justify-start">
                          {event.comment && (
                            <Card className={`${
                              isPending 
                                ? "border-gray-200 bg-gray-50" 
                                : isRejected 
                                ? "border-red-200 bg-red-50" 
                                : "border-blue-200 bg-blue-50"
                            } max-w-xs`}>
                              <CardContent className="p-4">
                                <div className={`text-sm font-semibold ${textColor} mb-2`}>{event.comment.title}</div>
                                <div className={`text-sm ${
                                  isPending 
                                    ? "text-gray-400" 
                                    : isRejected 
                                    ? "text-red-600" 
                                    : "text-blue-600"
                                }`}>{event.comment.content}</div>
                              </CardContent>
                            </Card>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
